import * as React from "react";
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import { Chip } from '@material-ui/core';

export const BooleanField = (props) => {
  const { source } = props;
  const record = useRecordContext(props);

  let label =  "Não ativo";
  let color = "#fff0f0";
  if (record[source]) {
    label = "Ativo";
    color = "#eefee6";

    const today = new Date();
    if (record['date_start']) {
      const dateStart = new Date(record['date_start']);
      if (dateStart > today) {
        label =  "Não ativo";
        color = "#fff0f0";
      }
    }
    if (record['date_end']) {
      const dateEnd = new Date(record['date_end']);
      if (dateEnd <= today) {
        label =  "Não ativo";
        color = "#fff0f0";
      }
    }
  }

  return <Chip
    label={label}
    size="small"
    style={{
      backgroundColor: color,
      border: 0
    }}
  />;
};

BooleanField.propTypes = {
  record: PropTypes.object,
};